import { authClient } from "@/shared/lib/axios";
import { rootRoute } from "@/routes";
import { Spinner, VStack } from "@/shared/ui/primitives";
import { createRoute, useNavigate } from "@tanstack/react-router";
import { useEffect, useState } from "react";

function OAuthGoogleConnectPage() {
	const navigate = useNavigate();
	const [error, setError] = useState<string | null>(null);

	useEffect(() => {
		let cancelled = false;

		void authClient
			.get<{ url?: string; error?: string }>("/oauth/google/connect/auth-url")
			.then(({ data }) => {
				if (cancelled) return;
				if (data.url) {
					window.location.href = data.url;
					return;
				}
				setError(data.error ?? "Google 연동 URL을 가져오지 못했습니다.");
			})
			.catch(() => {
				if (cancelled) return;
				navigate({ to: "/login", search: { returnUrl: "/oauth/google/connect" } });
			});
		return () => {
			cancelled = true;
		};
	}, [navigate]);

	if (error) {
		return (
			<VStack className="min-h-screen items-center justify-center gap-4 p-4">
				<span className="text-ct-strong font-medium">{error}</span>
				<a href="/" className="text-pm-strong text-sm underline">
					홈으로
				</a>
			</VStack>
		);
	}

	return (
		<VStack className="min-h-screen items-center justify-center gap-4 p-4">
			<Spinner size="md" />
			<span className="text-ct-regular text-sm">Google 연동 페이지로 이동 중...</span>
		</VStack>
	);
}

export const oauthGoogleConnectRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/oauth/google/connect",
	component: OAuthGoogleConnectPage,
});
